import { render, staticRenderFns } from "./routeWarehouseConfiguration.vue?vue&type=template&id=19c3abc7&scoped=true&"
import script from "./routeWarehouseConfiguration.vue?vue&type=script&lang=js&"
export * from "./routeWarehouseConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./routeWarehouseConfiguration.vue?vue&type=style&index=0&id=19c3abc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c3abc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c3abc7')) {
      api.createRecord('19c3abc7', component.options)
    } else {
      api.reload('19c3abc7', component.options)
    }
    module.hot.accept("./routeWarehouseConfiguration.vue?vue&type=template&id=19c3abc7&scoped=true&", function () {
      api.rerender('19c3abc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/routeWarehouseConfiguration.vue"
export default component.exports